import React from 'react';
import PropTypes from 'prop-types';
import Icon from "../icon/icon";
export var CLASSNAME = 'Icons-edit';
export var ID = 'icon-edit';
/* eslint-disable max-len */

export var SVGEdit = function SVGEdit() {
  return React.createElement("symbol", {
    id: ID,
    viewBox: "0 0 16 16"
  }, React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fillRule: "evenodd"
  }, React.createElement("g", null, React.createElement("path", {
    d: "M3,13 L9,13 L9,12 L11,12 L11,15 L1,15 L1,5 L4,5 L4,7 L3,7 L3,13 Z M12.1483189,0.851681076 C12.342547,0.657452981 12.661293,0.66129303 12.8559202,0.855920196 L15.1440798,3.1440798 C15.3406491,3.3406491 15.3433518,3.65664816 15.1483189,3.85168108 L8,11 L5,8 L12.1483189,0.851681076 Z M5,8 L8,11 L4,12 L5,8 Z M10.5,2.5 L11.5,1.5 L14.5,4.5 L13.5,5.5 L10.5,2.5 Z M5,8 L6,7 L9,10 L8,11 L5,8 Z"
  }))));
};
/* eslint-disable max-len */

var Edit = function Edit(props) {
  return React.createElement(Icon, {
    id: ID,
    className: props.className ? "".concat(props.className, " ").concat(CLASSNAME) : CLASSNAME,
    onClick: props.onClick,
    svg: SVGEdit
  });
};

Edit.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func
};
export default Edit;